import { Flex, Heading, Stack, Tag, TagLabel } from '@chakra-ui/react';

import { Modal } from '~/components/modal';

import { CheckIcon } from '../icons';

export function SkillsModal({
  isOpen,
  onClose,
  skillsByCourse,
  allSkills,
  programTitle,
}: {
  isOpen: boolean;
  skillsByCourse: Record<string, { courseTitle: string; skills: string[] }> | null;
  allSkills: string[];
  programTitle: string;
  onClose: () => void;
}) {
  return (
    <Modal
      isOpen={isOpen}
      size='3xl'
      title={
        <Heading as='header' size='heading-5'>
          {skillsByCourse ? 'Nanodegree Skills' : 'Course Skills'}
        </Heading>
      }
      onClose={onClose}
    >
      {skillsByCourse ? (
        <Stack spacing={8}>
          {Object.entries(skillsByCourse).map(([key, { courseTitle, skills }]) => (
            <CourseSkills key={key} skills={skills} title={courseTitle} />
          ))}
        </Stack>
      ) : (
        <CourseSkills skills={allSkills} title={programTitle} />
      )}
    </Modal>
  );
}

function CourseSkills({ title, skills }: { title: string; skills: string[] }) {
  return (
    <Flex flexDirection='column' gap={2}>
      <Flex alignItems='center' gap={2}>
        <CheckIcon color='primary.blue' height='32px' width='32px' />
        <Heading as='h3' size='heading-7'>
          {title}
        </Heading>
      </Flex>
      <Flex flexWrap='wrap' gap={2}>
        {skills.map((skill) => (
          <Tag key={skill} size='lg'>
            <TagLabel>{skill}</TagLabel>
          </Tag>
        ))}
      </Flex>
    </Flex>
  );
}
